export default __webpack_public_path__ + "static/media/gourmet.1434665f.svg";